import {
  Action,
  OperationType,
  Position,
  DOWNLOAD_INDICATOR_WIDGET,
  WidgetStage
} from '../../../../index';
import { WindowActionsEvent } from '@progress/kendo-react-dialogs';
import Widget from '../Widget';
import Connect from '../../../../utility/window/Connect';

class DownloadWidget extends Widget {
  /**
   * @inheritDoc
   */
  public getCloseWidgetAction(): Action {
    let action: Action = super.getCloseWidgetAction();

    if (this.moduleId === DOWNLOAD_INDICATOR_WIDGET) {
      const actionName: string = this.getCloseActionName();
      action = [{
        actionName,
        items: ['closingWidget'],
        type: OperationType.syncDispatchersDataItem
      }, {
        actionName,
        condition: '{closingWidget} || {numberOfActiveDownloads()} === 0',
        conditionOperations: [{
          name: 'closeAndUnlinkDownloadIndicatorWidget',
          type: OperationType.action
        }],
        type: OperationType.conditional
      }, ...action];
    }
    return action;
  }

  /**
   * @inheritDoc
   * Disable widget action buttons for download widget.
   */
  protected getWidgetActionButton = (props: any, type: 'minimize' | 'maximize' | 'restore') => null;

  /**
   * Closes Widget with passed moduleId.
   * @param moduleId
   * @param activeDownloadCount If moduleId has value of DOWNLOAD_INDICATOR_WIDGET, then widget won't be closed
   * until all downloads are finished.
   */
  public close = (moduleId: string, activeDownloadCount: number = 0): void => {
    if (this.moduleId === moduleId) {
      const isDownloadIndicatorWidget: boolean = moduleId === DOWNLOAD_INDICATOR_WIDGET;
      let visible: boolean = false;

      if (isDownloadIndicatorWidget) {
        visible = activeDownloadCount !== 0;
      }

      if (!visible) {
        this.setState({ visible });
        this.unmountWidget();
      }
    }
  };

  /**
   * @inheritDoc
   */
  doCloseWidget() {
    const closeAction = this.closeAction || this.getCloseActionName();
    const data = { closingWidget: true };
    this.dispatch(closeAction, Position.end, data);

    if (this.escapeActionName) {
      this.dispatch(this.escapeActionName, Position.end);
    }
  }

  /**
   * @inheritDoc
   * Prevents showing FULLSCREEN mode on header double click event.
   */
  public handleStageChange(e: WindowActionsEvent) {
    const stage = e.state;
    if (stage === WidgetStage.fullScreen) {
      e.state = WidgetStage.minimized;
    }
    super.handleStageChange(e);
  }

  /**
   * @inheritDoc Clean up dom after download widget is closed.
   */
  unmountWidget() {
    super.unmountWidget();
    Connect.removeDownloadFrames();
  }
}

export default DownloadWidget;
